import {isRtl} from 'scratch-l10n';
import editorMessages from 'scratch-l10n/locales/editor-msgs';

const UPDATE_LOCALES = 'scratch-gui/locales/UPDATE_LOCALES';
const SELECT_LOCALE = 'scratch-gui/locales/SELECT_LOCALE';

const messagesByLocale = {
    ...editorMessages,
    'zh-cn': {
        ...editorMessages['zh-cn'],
        'gui.projectJson.title': '代码对照',
        'gui.projectJson.toggle': '代码对照',
        'gui.projectJson.python': 'Python',
        'gui.projectJson.json': 'JSON',
        'gui.projectJson.pythonContent': '只读 Python',
        'gui.projectJson.pythonHint': '仅供教学对照，不能直接运行或烧录；示意 API 需要运行环境。未支持积木：{count} 处（已在代码中标注）。',
        'gui.projectJson.scope': '查看范围',
        'gui.projectJson.target': '当前角色 / 舞台',
        'gui.projectJson.project': '整个项目',
        'gui.projectJson.close': '关闭代码对照',
        'gui.projectJson.content': '只读 JSON',
        'gui.projectJson.refresh': '刷新',
        'gui.projectJson.copy': '复制',
        'gui.projectJson.download': '下载 {format}',
        'gui.projectJson.copied': '已复制',
        'gui.projectJson.copyFailed': '无法访问剪贴板，请选中文本手动复制，或下载代码。',
        'gui.projectJson.error': '生成代码失败，请尝试刷新面板。',
        'gui.projectJson.hint': '只读，随积木修改自动更新。opcode 表示积木类型，next 指向下一块，inputs 包含参数和分支。',
        'gui.projectJson.assetsHint': 'JSON 不包含图片和声音文件；保存完整作品请使用 .sb3 格式。',
        'gui.aria.editMenu': '编辑菜单',
        'gui.aria.fileMenu': '文件菜单',
        'gui.aria.settingsMenu': '设置菜单',
        'gui.blockTheme.catBlocks': '猫咪积木',
        'gui.blockTheme.default': '默认',
        'gui.burnCenter.deviceSelector.close': '关闭',
        'gui.burnCenter.deviceSelector.domiCar': 'Domi 小车',
        'gui.burnCenter.deviceSelector.domiCarDescription': '检查并写入小车离线程序。',
        'gui.burnCenter.deviceSelector.emptyHelp': '请先添加 micro:bit 或 Domi 小车扩展，然后再打开烧录中心。',
        'gui.burnCenter.deviceSelector.emptyTitle': '当前没有已加载且支持烧录的硬件扩展。',
        'gui.burnCenter.deviceSelector.intro': '请选择本次要烧录的设备，列表来自当前项目已加载的硬件扩展。',
        'gui.burnCenter.deviceSelector.microbit': 'micro:bit',
        'gui.burnCenter.deviceSelector.microbitDescription': '编译离线程序并通过 USB 写入设备。',
        'gui.burnCenter.deviceSelector.title': '选择烧录设备',
        'gui.confirmationPrompt.cancel': '取消',
        'gui.confirmationPrompt.confirm': '删除',
        'gui.extension.domiCar.description': '通过 Wi-Fi 控制摄像小车。',
        'gui.extension.domiCar.name': 'Domi 小车',
        'gui.extension.domiRobotDog.description': '通过 Wi-Fi 控制四足机器人移动和表演。',
        'gui.extension.domiRobotDog.name': 'Domi 四足机器人',
        'gui.extension.domiController.description': '为 Domi 蓝牙控制器的方向键和功能键编程。',
        'gui.extension.domiController.name': 'Domi 控制器',
        'gui.extension.domiAiRound.description': '通过 USB 或 Wi-Fi 控制 AI 圆屏。',
        'gui.extension.domiAiRound.name': 'Domi AI 圆屏',
        'gui.hardwareDevicePane.addDevice': '添加设备',
        'gui.hardwareDevicePane.address': '小车地址',
        'gui.hardwareDevicePane.autoReconnectFailed': '未检测到上次连接的小车，请确认小车电源和网络后重试。',
        'gui.hardwareDevicePane.autoReconnectSuccess': '已自动连接上次使用的小车。',
        'gui.hardwareDevicePane.bluetooth': '蓝牙',
        'gui.hardwareDevicePane.connectBluetooth': '连接蓝牙',
        'gui.hardwareDevicePane.connectCar': '连接小车',
        'gui.hardwareDevicePane.connectRound': '连接圆屏',
        'gui.hardwareDevicePane.connectFailed': '连接失败：{message}',
        'gui.hardwareDevicePane.connected': '设备已连接',
        'gui.hardwareDevicePane.connecting': '正在连接…',
        'gui.hardwareDevicePane.connectionHeading': '连接方式',
        'gui.hardwareDevicePane.connectionLost': '小车连接已断开，请重新连接。',
        'gui.hardwareDevicePane.connectUnavailable': 'Domi 小车连接服务不可用。',
        'gui.hardwareDevicePane.emptyDescription': '从扩展库添加 Domi 小车、四足机器人、AI 圆屏或 micro:bit 后，就能在这里连接设备。',
        'gui.hardwareDevicePane.dogAddress': '四足机器人地址',
        'gui.hardwareDevicePane.connectDog': '连接四足机器人',
        'gui.hardwareDevicePane.dogWifiHelp': '先在电脑的 Wi-Fi 设置中连接四足机器人热点（Robot - xxxx），再点击连接。默认地址为 192.168.4.1。',
        'gui.hardwareDevicePane.dogOnlineHelp': '当前支持在线控制，连接后可直接运行四足机器人积木。停止后，已执行的动作可能需要完成才会恢复站立。',
        'gui.hardwareDevicePane.dogReachable': '最近通信成功',
        'gui.hardwareDevicePane.dogUnavailable': '四足机器人连接服务不可用，请重新添加扩展。',
        'gui.hardwareDevicePane.dogNotReachable': '没有连接到四足机器人，请确认已连接四足机器人热点，并检查电源和地址。',
        'gui.hardwareDevicePane.dogConnectionLost': '四足机器人通信失败，请检查网络后重新连接。',
        'gui.hardwareDevicePane.emptyTitle': '还没有添加硬件设备',
        'gui.hardwareDevicePane.firmwareVersion': '固件 {version}',
        'gui.hardwareDevicePane.modeHeading': '编程模式',
        'gui.hardwareDevicePane.notConnected': '等待连接设备',
        'gui.hardwareDevicePane.notReachable': '没有连接到小车，请检查地址和网络。',
        'gui.hardwareDevicePane.online': '在线',
        'gui.hardwareDevicePane.onlineHelp': '运行 Scratch 积木时，指令会立即发送到设备。',
        'gui.hardwareDevicePane.openBurnCenter': '打开烧录中心',
        'gui.hardwareDevicePane.openDeviceCenter': '打开设备中心',
        'gui.hardwareDevicePane.reconnectBluetooth': '管理蓝牙连接',
        'gui.hardwareDevicePane.reconnectCar': '重新连接',
        'gui.hardwareDevicePane.serial': 'USB 串口',
        'gui.hardwareDevicePane.serialHelp': '用于安装小车固件和配置 Wi-Fi，日常控制使用 Wi-Fi。',
        'gui.hardwareDevicePane.roundAddress': '圆屏地址',
        'gui.hardwareDevicePane.roundAutoReconnectFailed': '未检测到上次连接的圆屏，请确认圆屏和电脑处于同一 Wi-Fi。',
        'gui.hardwareDevicePane.roundAutoReconnectSuccess': '已自动连接上次使用的圆屏。',
        'gui.hardwareDevicePane.roundConnectionLost': '圆屏连接已断开，请重新连接。',
        'gui.hardwareDevicePane.roundNotReachable': '没有连接到圆屏，请检查 IP 地址、Wi-Fi 或 USB 数据线。',
        'gui.hardwareDevicePane.roundUnavailable': 'Domi AI 圆屏连接服务不可用。',
        'gui.hardwareDevicePane.roundUsbHelp': '通过 USB 数据线实时控制圆屏，浏览器会请求串口权限。',
        'gui.hardwareDevicePane.roundWifiHelp': '先在圆屏打开 Domi 配网并连接同一网络，再填写圆屏显示的 IP 地址。',
        'gui.hardwareDevicePane.upload': '上传',
        'gui.hardwareDevicePane.uploadHelp': '把当前项目编译并写入设备，脱离 Scratch 后也能运行。',
        'gui.hardwareDevicePane.usb': 'USB',
        'gui.hardwareDevicePane.verifiedCar': '已验证为 Domi 小车',
        'gui.hardwareDevicePane.verifiedRound': '已验证为 Domi AI 圆屏',
        'gui.hardwareDevicePane.wifi': 'Wi-Fi',
        'gui.domiCloud.autoSaveFailed': '自动保存失败，修改仍保留在当前工作区。',
        'gui.domiCloud.autoSaved': '已自动保存',
        'gui.domiCloud.autoSaving': '正在自动保存…',
        'gui.domiCloud.projectsEmpty': '还没有云端项目，先保存当前项目吧。',
        'gui.domiCloud.history': '我的云端作品',
        'gui.domiCloud.loading': '正在加载云端作品…',
        'gui.domiCloud.open': '打开',
        'gui.domiCloud.opening': '正在打开…',
        'gui.domiCloud.replaceWarning': '打开这个作品会替换当前工作区，是否继续？',
        'gui.domiCloud.save': '保存到云端',
        'gui.domiCloud.saved': '作品已保存到云端。',
        'gui.domiCloud.saving': '正在保存到云端…',
        'gui.domiCloud.title': '我的云端作品',
        'gui.domiCloud.untitledProject': 'Domi Scratch 作品',
        'gui.domiDeviceCenter.connectCancelled': '没有选择 USB 设备。',
        'gui.domiDeviceCenter.downloadMode': '无法进入下载模式。请按住 IO0，轻按 RESET，然后重试。',
        'gui.domiDeviceCenter.firmwareUnavailable': '无法下载 Domi 固件，请检查网络或选择本地 .bin 文件。',
        'gui.domiDeviceCenter.genericError': '操作失败：{message}',
        'gui.domiDeviceCenter.portBusy': 'USB 串口正在使用中，请关闭 Arduino 串口监视器后重试。',
        'gui.domiDeviceCenter.serialUnavailable': '请使用桌面版 Chrome 或 Edge，并通过 HTTPS 打开网站。',
        'gui.domiDeviceCenter.title': 'Domi 设备中心',
        'gui.domiDeviceCenter.wifiTimeout': '小车没有连接上 Wi-Fi，请检查网络名称和密码。',
        'gui.domiControllerSimulator.connected': '小车已通过 Wi-Fi 连接，可以进行实车联调。',
        'gui.domiControllerSimulator.disconnected': '小车尚未连接。按键事件仍会运行，但小车积木暂时不能控制实车。',
        'gui.domiControllerSimulator.down': '下方向键',
        'gui.domiControllerSimulator.emergencyStop': '立即停车',
        'gui.domiControllerSimulator.eventItem': '{button} {action}',
        'gui.domiControllerSimulator.introduction': '按住按钮模拟实体控制器，松开时触发对应的松开事件。',
        'gui.domiControllerSimulator.left': '左方向键',
        'gui.domiControllerSimulator.noEvents': '按下一个控制器按钮开始联调。',
        'gui.domiControllerSimulator.open': '控制器',
        'gui.domiControllerSimulator.pressed': '按下',
        'gui.domiControllerSimulator.recentEvents': '最近事件',
        'gui.domiControllerSimulator.released': '松开',
        'gui.domiControllerSimulator.right': '右方向键',
        'gui.domiControllerSimulator.safetyHelp': '关闭窗口或切换到其他页面时，小车会自动停车。',
        'gui.domiControllerSimulator.title': '控制器模拟器',
        'gui.domiControllerSimulator.up': '上方向键',
        'gui.domiExamples.action.arrowKeys': '按住方向键 = 移动，松开 = 停止',
        'gui.domiExamples.action.burnCenter': '从烧录中心写入小车',
        'gui.domiExamples.action.forwardOneSecond': '前进 1 秒',
        'gui.domiExamples.action.greenFlag': '点击绿旗',
        'gui.domiExamples.action.greenFlagCamera': '绿旗 = 打开摄像头',
        'gui.domiExamples.action.lightOff': '关闭车灯',
        'gui.domiExamples.action.lightOn': '打开车灯',
        'gui.domiExamples.action.challengeCameraLight': 'C / X 控制摄像头，L / O 控制车灯',
        'gui.domiExamples.action.challengeDrive': '方向键根据驾驶模式按步或按住行驶',
        'gui.domiExamples.action.challengeEmergency': '空格键执行紧急停车',
        'gui.domiExamples.action.challengeGears': '数字键 1 / 2 / 3 只切换前进、后退三档步长',
        'gui.domiExamples.action.challengeModes': '数字键 4 = 按步行驶，5 = 按住行驶',
        'gui.domiExamples.action.challengePatrol': 'P 键启动两圈自动巡逻',
        'gui.domiExamples.action.challengeVariables': '用变量记录挡位、状态和动作次数',
        'gui.domiExamples.action.lapLightSignal': '每圈结束闪灯提示',
        'gui.domiExamples.action.finishMission': '停止并关闭摄像头',
        'gui.domiExamples.action.openCameraAndLight': '打开摄像头和车灯',
        'gui.domiExamples.action.powerOn': '当小车开机时',
        'gui.domiExamples.action.repeatFour': '重复 4 次',
        'gui.domiExamples.action.repeatFourSides': '每圈重复行驶 4 条边',
        'gui.domiExamples.action.repeatTwoLaps': '重复巡逻 2 圈',
        'gui.domiExamples.action.spaceCamera': '空格键 = 关闭摄像头',
        'gui.domiExamples.action.spaceStop': '空格键 = 立即停车',
        'gui.domiExamples.action.squareRoute': '重复方形路线',
        'gui.domiExamples.action.stop': '停止小车',
        'gui.domiExamples.action.turnRight': '右转 0.45 秒',
        'gui.domiExamples.action.waitOneSecond': '等待 1 秒',
        'gui.domiExamples.advanced': '高级',
        'gui.domiExamples.beginner': '入门',
        'gui.domiExamples.backToDevices': '返回设备列表',
        'gui.domiExamples.camera.description': '点击绿旗打开小车摄像头，按空格键关闭画面。',
        'gui.domiExamples.camera.title': '查看小车摄像头',
        'gui.domiExamples.cancel': '关闭示例中心',
        'gui.domiExamples.challenge.description': '方向键可以切换按步或按住行驶模式，前进、后退支持三档步长，左右转固定 0.3 秒，并组合自制积木、摄像头和车灯快捷键以及两圈自动巡逻。',
        'gui.domiExamples.challenge.title': '高级综合驾驶挑战',
        'gui.domiExamples.chooseDevice': '选择一个设备',
        'gui.domiExamples.chooseDeviceHelp': '每个示例都会自动加载所需扩展和完整积木程序。',
        'gui.domiExamples.comingSoon': '即将上线',
        'gui.domiExamples.device.domiCar.description': '运动、灯光、摄像头和离线路线',
        'gui.domiExamples.device.domiCar.title': 'Domi 小车',
        'gui.domiExamples.device.domiAiRound.description': '显示、触摸和互动游戏',
        'gui.domiExamples.device.domiAiRound.title': 'Domi AI 圆屏',
        'gui.domiExamples.device.microbit.description': 'LED、按键、姿态和传感器',
        'gui.domiExamples.device.microbit.title': 'micro:bit',
        'gui.domiExamples.deviceIntro': '先选择设备，再查看可以直接用于课堂的示例程序。',
        'gui.domiExamples.examplesCount': '{count} 个示例',
        'gui.domiExamples.forward.description': '点击绿旗，让小车前进 1 秒后自动停止。',
        'gui.domiExamples.forward.title': '前进一秒并停止',
        'gui.domiExamples.intro': '选择一个案例查看效果，确认后把完整积木程序加载到编辑器。',
        'gui.domiExamples.keyboard.description': '按住方向键持续移动、松开立即停止；按空格键立即停车。',
        'gui.domiExamples.keyboard.title': '方向键遥控小车',
        'gui.domiExamples.light.description': '打开小车灯 1 秒，然后自动关闭。',
        'gui.domiExamples.light.title': '小车灯光演示',
        'gui.domiExamples.loadError': '示例加载失败，请稍后重试。',
        'gui.domiExamples.loading': '正在加载示例…',
        'gui.domiExamples.mode.offline': '离线程序',
        'gui.domiExamples.mode.online': '实时控制',
        'gui.domiExamples.mission.description': '使用两层循环完成两圈巡逻，并组合摄像头、灯光提示和结束动作。',
        'gui.domiExamples.mission.title': '综合巡逻任务',
        'gui.domiExamples.offline.description': '可从烧录中心写入小车，并在小车开机后运行的方形路线。',
        'gui.domiExamples.offline.title': '离线方形路线',
        'gui.domiExamples.offlineHelp': '加载后，请打开烧录中心检查程序，再写入小车。',
        'gui.domiExamples.patrol.description': '重复执行前进和右转，让小车沿方形路线巡逻。',
        'gui.domiExamples.patrol.title': '方形巡逻路线',
        'gui.domiExamples.preview': '预览效果',
        'gui.domiExamples.programIncludes': '这个示例包含',
        'gui.domiExamples.replaceWarning': '加载示例会替换当前工作区，是否继续？',
        'gui.domiExamples.safety': '加载示例不会自动启动小车。请先连接小车，再点击绿旗或触发对应事件。',
        'gui.domiExamples.safety.car': '加载示例不会自动启动小车。请先连接小车，再点击绿旗或触发对应事件。',
        'gui.domiExamples.safety.round': '请先在右下角设备区通过 Wi-Fi 或 USB 连接圆屏，再点击绿旗。',
        'gui.domiExamples.round.action.alternateColors': '使用条件判断交替显示两种颜色',
        'gui.domiExamples.round.action.animateResult': '用条件判断画出对应骰面，并加入灯光和音效',
        'gui.domiExamples.round.action.checkIn': '触摸后切换胸牌签到状态',
        'gui.domiExamples.round.action.connect': '通过 USB 或 Wi-Fi 连接圆屏',
        'gui.domiExamples.round.action.countTouches': '统计并显示触摸次数',
        'gui.domiExamples.round.action.cyclePaint': '使用变量和条件循环三种画笔颜色',
        'gui.domiExamples.round.action.divideZones': '使用条件判断划分四个触摸区域',
        'gui.domiExamples.round.action.drawBadge': '组合渐变、进度环、图标和坐标文字',
        'gui.domiExamples.round.action.drawPet': '使用图标、渐变和进度环搭建精致宠物界面',
        'gui.domiExamples.round.action.detectShake': '响应圆屏内置的摇一摇传感器',
        'gui.domiExamples.round.action.hitTest': '计算触摸点是否命中目标',
        'gui.domiExamples.round.action.keepScore': '累计得分并绘制下一回合',
        'gui.domiExamples.round.action.moveSprite': '通过圆屏移动 Scratch 小猫',
        'gui.domiExamples.round.action.paintAtTouch': '在当前触摸坐标绘制圆点',
        'gui.domiExamples.round.action.petEnergy': '把宠物能量限制在 0 到 5',
        'gui.domiExamples.round.action.petMood': '喂食或消耗能量时切换表情',
        'gui.domiExamples.round.action.petDashboard': '使用双层圆环制作宠物状态仪表盘',
        'gui.domiExamples.round.action.petDance': '摇一摇触发带灯光、动画和声音的舞会',
        'gui.domiExamples.round.action.petTouchZones': '把左右触摸区域分别设为喂食和玩耍',
        'gui.domiExamples.round.action.powerDashboard': '把电量同时显示为文字和圆形进度仪表',
        'gui.domiExamples.round.action.randomWait': '随机等待一段时间',
        'gui.domiExamples.round.action.randomTarget': '随机生成目标位置',
        'gui.domiExamples.round.action.randomDice': '随机生成并保存 1 到 6 的点数',
        'gui.domiExamples.round.action.readBattery': '读取内置电量计的真实电量',
        'gui.domiExamples.round.action.readCoordinates': '读取触摸点的 X、Y 坐标',
        'gui.domiExamples.round.action.readTilt': '读取前后、左右两个方向的倾斜角度',
        'gui.domiExamples.round.action.rhythmLevelUp': '连续完美命中十次后播放升级庆祝效果',
        'gui.domiExamples.round.action.rhythmLoop': '组合三轨灯光、节拍动画和提示音',
        'gui.domiExamples.round.action.rhythmTiming': '使用计时器判断触摸时机并累计连击',
        'gui.domiExamples.round.action.mapPosition': '把传感器角度换算为屏幕坐标',
        'gui.domiExamples.round.action.spaceCollision': '检测飞船和陨石碰撞并更新得分',
        'gui.domiExamples.round.action.spaceShield': '使用触摸和摇动触发护盾及超级跳跃',
        'gui.domiExamples.round.action.spaceSteer': '把倾斜数据换算成飞船的左右位置',
        'gui.domiExamples.round.action.liveRedraw': '组合丝滑增量运动、多层光晕、充能和声音反馈',
        'gui.domiExamples.round.action.showResult': '在圆屏上显示挑战结果',
        'gui.domiExamples.round.action.timer': '使用计时器测量反应速度',
        'gui.domiExamples.round.action.touchEvent': '响应圆屏触摸事件',
        'gui.domiExamples.round.action.welcome': '设置亮度、颜色和欢迎文字',
        'gui.domiExamples.round.badge.description': '设计一张带渐变、图标和庆祝动画的发光电子胸牌。',
        'gui.domiExamples.round.badge.title': '魔法签到胸牌',
        'gui.domiExamples.round.batteryStation.description': '触摸圆屏，读取真实电量并生成圆形仪表盘。',
        'gui.domiExamples.round.batteryStation.title': '触摸电量站',
        'gui.domiExamples.round.controller.description': '把圆屏划分为四个区域，通过触摸坐标移动 Scratch 小猫。',
        'gui.domiExamples.round.controller.title': '四区触摸遥控角色',
        'gui.domiExamples.round.hello.description': '连接圆屏，制作一张彩色欢迎卡。',
        'gui.domiExamples.round.hello.title': 'Hello 圆屏',
        'gui.domiExamples.round.paint.description': '直接在圆屏上画彩色圆点，并循环切换三种画笔颜色。',
        'gui.domiExamples.round.paint.title': '彩虹手指画板',
        'gui.domiExamples.round.pet.description': '喂养会动的机器人宠物，观察颜色、图标和能量环的反馈。',
        'gui.domiExamples.round.pet.title': 'Domi 电子宠物',
        'gui.domiExamples.round.petAdventure.description': '照顾拥有饱食度、快乐值和等级的宠物，通过喂食、玩耍和摇一摇开启舞会。',
        'gui.domiExamples.round.petAdventure.title': 'AI 宠物成长冒险',
        'gui.domiExamples.round.reaction.description': '等待屏幕变绿后立即触摸，查看自己的反应时间。',
        'gui.domiExamples.round.reaction.title': '反应速度挑战',
        'gui.domiExamples.round.target.description': '点击随机出现的发光目标，观察外圈得分进度不断增长。',
        'gui.domiExamples.round.target.title': '目标猎手挑战',
        'gui.domiExamples.round.shakeDice.description': '摇动圆屏，掷出带真实六面骰图案、灯光、动画和音效的幸运骰子。',
        'gui.domiExamples.round.shakeDice.title': '摇一摇幸运骰子',
        'gui.domiExamples.round.rhythmPlanet.description': '跟随三轨发光节拍，在准确时机触摸圆屏，挑战连续十次完美命中。',
        'gui.domiExamples.round.rhythmPlanet.title': '节奏星球挑战',
        'gui.domiExamples.round.spaceDodger.description': '倾斜圆屏驾驶发光飞船躲避陨石，触摸开启护盾，摇一摇进行超级跳跃。',
        'gui.domiExamples.round.spaceDodger.title': '星际飞船陨石逃生',
        'gui.domiExamples.round.tiltOrbit.description': '倾斜、触摸或摇动设备，控制并充能一个带光晕和音效的能量核心。',
        'gui.domiExamples.round.tiltOrbit.title': '倾斜控制能量球',
        'gui.domiExamples.round.touchColor.description': '每次触摸都会切换颜色，并更新触摸计数。',
        'gui.domiExamples.round.touchColor.title': '触摸变色',
        'gui.domiExamples.title': '示例中心',
        'gui.domiExamples.useExample': '使用这个示例',
        'gui.domiExamples.controllerDriving.title': '蓝牙控制器驾驶',
        'gui.domiExamples.controllerDriving.description': '给方向键、OK 和 A～F 键编程，可先用网页遥控器预览，再烧录进小车。',
        'gui.domiExamples.action.controllerDirections': '按住方向键行驶，松开停止',
        'gui.domiExamples.action.controllerLights': 'OK = 切换车灯',
        'gui.domiExamples.action.controllerFunctionLights': 'A / B = 打开 / 关闭车灯',
        'gui.domiExamples.action.controllerFunctionMoves': 'C / D = 前进 / 后退 1 秒；E / F = 左转 / 右转 0.3 秒',
        'gui.domiExamples.action.controllerBurn': '从烧录中心写入小车',
        'gui.gui.deleteAssetHeading': '确认删除素材',
        'gui.gui.shouldDeleteCostume': '确定要删除这个造型吗？',
        'gui.gui.shouldDeleteSound': '确定要删除这个声音吗？',
        'gui.gui.shouldDeleteSprite': '确定要删除这个角色吗？',
        'gui.menuBar.colorMode': '颜色模式',
        'gui.menuBar.deviceCenter': '设备中心',
        'gui.menuBar.domiExamples': '示例中心',
        'gui.menuBar.language': '语言',
        'gui.menuBar.settings': '设置',
        'gui.menuBar.theme': '积木主题',
        'gui.sharedMessages.loadFromComputerTitle': '从电脑中上传',
        'gui.theme.dark': '深色',
        'gui.theme.default': '原始',
        'gui.theme.highContrast': '高对比度',
        'domiCar.connect': '连接小车 [ADDRESS]',
        'domiCar.direction.backward': '后退',
        'domiCar.direction.forward': '前进',
        'domiCar.direction.left': '左转',
        'domiCar.direction.right': '右转',
        'domiCar.isConnected': '小车已连接？',
        'domiCar.holdKeyMove': '按住 [KEY] 键时，小车 [DIRECTION]',
        'domiCar.key.down': '下方向键',
        'domiCar.key.left': '左方向键',
        'domiCar.key.right': '右方向键',
        'domiCar.key.up': '上方向键',
        'domiCar.light.off': '关闭',
        'domiCar.light.on': '打开',
        'domiCar.move': '小车 [DIRECTION]',
        'domiCar.moveForSeconds': '小车 [DIRECTION] [SECONDS] 秒',
        'domiCar.name': 'Domi 小车',
        'domiCar.openCameraView': '打开摄像头画面',
        'domiCar.closeCameraView': '关闭摄像头画面',
        'domiCar.offline.clear': '清除小车离线程序',
        'domiCar.offline.cleared': '离线程序已清除',
        'domiCar.offline.compileFailed': '无法编译离线程序。',
        'domiCar.offline.connectFirst': '请先连接小车，再写入离线程序。',
        'domiCar.offline.dynamicInput': '离线程序中的等待和重复次数必须填写固定数字。',
        'domiCar.offline.multipleEntries': '只能保留一段“当小车开机时”程序。',
        'domiCar.offline.noEntry': '请先搭建一段小车开机或 Domi 控制器事件程序。',
        'domiCar.offline.duplicateEvent': '每一种控制器按键动作只能保留一段程序。',
        'domiCar.offline.notUploaded': '还没有写入离线程序',
        'domiCar.offline.repeatRange': '离线程序每次最多重复 100 次。',
        'domiCar.offline.requestFailed': '小车没有接受离线程序命令。',
        'domiCar.offline.start': '启动小车离线程序',
        'domiCar.offline.started': '离线程序已启动',
        'domiCar.offline.status': '离线程序状态',
        'domiCar.offline.stop': '停止小车离线程序',
        'domiCar.offline.stopped': '离线程序已停止',
        'domiCar.offline.tooLarge': '离线程序太长，请减少积木或重复次数。',
        'domiCar.offline.unsupportedBlock': '程序中包含暂不支持离线运行的积木。',
        'domiCar.offline.waitRange': '离线程序每次等待必须在 0 到 60 秒之间。',
        'domiCar.offline.write': '将开机程序写入小车',
        'domiCar.offline.writeFailed': '离线程序写入失败',
        'domiCar.offline.writing': '正在写入离线程序…',
        'domiCar.offline.written': '写入成功（{count} 条指令）',
        'domiCar.setLight': '将小车灯 [STATE]',
        'domiCar.toggleLight': '切换小车灯',
        'domiCar.stop': '停止小车',
        'domiCar.whenCarStarts': '当小车开机时',
        'domiRobotDog.action.dance1': '跳舞 1',
        'domiRobotDog.action.dance2': '跳舞 2',
        'domiRobotDog.action.dance3': '跳舞 3',
        'domiRobotDog.action.fight': '格斗',
        'domiRobotDog.action.hello': '打招呼',
        'domiRobotDog.action.pushUp': '做俯卧撑',
        'domiRobotDog.action.sleep': '睡觉',
        'domiRobotDog.connect': '连接四足机器人 [ADDRESS]',
        'domiRobotDog.isConnected': '四足机器人已连接？',
        'domiRobotDog.move': '四足机器人 [MOVEMENT]',
        'domiRobotDog.movement.backward': '后退一步',
        'domiRobotDog.movement.forward': '前进一步',
        'domiRobotDog.movement.lieDown': '趴下',
        'domiRobotDog.movement.shiftLeft': '向左平移',
        'domiRobotDog.movement.shiftRight': '向右平移',
        'domiRobotDog.movement.turnLeft': '向左转',
        'domiRobotDog.movement.turnRight': '向右转',
        'domiRobotDog.name': 'Domi 四足机器人',
        'gui.domiExamples.device.robotDog.title': 'Domi 四足机器人',
        'gui.domiExamples.device.robotDog.description': '行走、姿态与趣味才艺表演',
        'gui.domiExamples.safety.robotDog': '先连接四足机器人热点，再在右下角设备面板连接，点击绿旗开始。预览为效果示意；停止时，四足机器人正在执行的动作可能需要完成才会停下。',
        'gui.domiExamples.robotDogShow.title': '四足机器人才艺秀',
        'gui.domiExamples.robotDogShow.description': '跟着解说打招呼、做俯卧撑，重复两轮后跳舞谢幕。学习条件判断、循环和动作间隔。',
        'gui.domiExamples.robotDogShow.connect': '在设备面板连接四足机器人',
        'gui.domiExamples.robotDogShow.repeat': '打招呼＋俯卧撑，重复两轮',
        'gui.domiExamples.robotDogShow.dance': '舞蹈收尾，恢复站立',
        'gui.domiExamples.robotDogShow.edit': '自由修改动作顺序、次数和间隔',
        'gui.domiExamples.dogKeyboard.title': '键盘遥控训练场',
        'gui.domiExamples.dogKeyboard.description': '方向键控制单次行走，数字键触发才艺。学习按键事件，并用“正在表演”变量避免多个动作同时触发。',
        'gui.domiExamples.dogKeyboard.start': '连接四足机器人后，先点击绿旗初始化',
        'gui.domiExamples.dogKeyboard.arrows': '方向键：前进、后退、左转、右转',
        'gui.domiExamples.dogKeyboard.tricks': '1 打招呼、2 俯卧撑、3 跳舞；空格恢复站立',
        'gui.domiExamples.dogKeyboard.pacing': '一次执行一个动作，不是按住连续行走',
        'gui.domiExamples.dogBlindBox.title': '随机才艺盲盒',
        'gui.domiExamples.dogBlindBox.description': '按空格随机抽取打招呼、俯卧撑或跳舞，看看这次会表演什么。学习随机数、变量和条件分支。',
        'gui.domiExamples.dogBlindBox.draw': '点击绿旗后，按空格抽取节目',
        'gui.domiExamples.dogBlindBox.result': '舞台变量显示抽中的节目编号',
        'gui.domiExamples.dogBlindBox.branch': '三个条件对应三种不同表演',
        'gui.domiExamples.dogBlindBox.edit': '替换动作，尝试增加新的随机结果',
        'gui.domiExamples.dogFitness.title': '四足机器人健身教练',
        'gui.domiExamples.dogFitness.description': '自选 1～3 轮训练，俯卧撑与休息交替进行，记录进度并挥手庆祝。学习可调次数的循环和计数变量。',
        'gui.domiExamples.dogFitness.rounds': '点击绿旗后，用 1/2/3 选择训练轮数',
        'gui.domiExamples.dogFitness.start': '空格开始训练，默认两轮',
        'gui.domiExamples.dogFitness.rest': '俯卧撑、恢复站立、休息后完成一轮',
        'gui.domiExamples.dogFitness.counter': '舞台显示“已完成轮数”，观察训练进度',
        'domiRobotDog.sayHello': '四足机器人打招呼',
        'domiRobotDog.fight': '四足机器人格斗',
        'domiRobotDog.pushUp': '四足机器人做俯卧撑',
        'domiRobotDog.sleep': '四足机器人睡觉',
        'domiRobotDog.perform': '四足机器人表演 [ACTION]',
        'domiRobotDog.standby': '四足机器人恢复站立',
        'domiController.down': '下方向键',
        'domiController.left': '左方向键',
        'domiController.name': 'Domi 控制器',
        'domiController.pressed': '按下',
        'domiController.released': '松开',
        'domiController.right': '右方向键',
        'domiController.up': '上方向键',
        'domiController.whenButtonAction': '当控制器 [BUTTON] [ACTION] 时',
        'domiAiRound.beginFrame': '开始绘制新画面',
        'domiAiRound.clearScreen': '清空圆屏',
        'domiAiRound.commitFrame': '一次显示新画面',
        'domiAiRound.connectUsb': '连接 Domi AI 圆屏',
        'domiAiRound.connectWifi': '通过 Wi-Fi 连接圆屏 [ADDRESS]',
        'domiAiRound.disconnectUsb': '断开圆屏',
        'domiAiRound.displayTextAt': '在圆屏 x [X] y [Y] 显示 [TEXT] 大小 [SIZE] 颜色 [COLOR]',
        'domiAiRound.displayText': '在圆屏显示 [TEXT]',
        'domiAiRound.drawCircle': '在圆屏 x [X] y [Y] 画半径 [RADIUS] 的 [STYLE] 圆形 颜色 [COLOR]',
        'domiAiRound.drawRectangle': '在圆屏 x [X] y [Y] 画宽 [WIDTH] 高 [HEIGHT] 的 [STYLE] 矩形 颜色 [COLOR]',
        'domiAiRound.animation.bounce': '跳动',
        'domiAiRound.animation.pulse': '呼吸',
        'domiAiRound.animation.shake': '摇摆',
        'domiAiRound.gradientDirection.horizontal': '从左到右',
        'domiAiRound.gradientDirection.vertical': '从上到下',
        'domiAiRound.icon.heart': '爱心',
        'domiAiRound.icon.robot': '机器人',
        'domiAiRound.icon.smile': '笑脸',
        'domiAiRound.icon.sparkle': '闪光',
        'domiAiRound.icon.trophy': '奖杯',
        'domiAiRound.isConnected': '圆屏已连接？',
        'domiAiRound.isTouched': '圆屏被触摸？',
        'domiAiRound.acceleration': '圆屏 [AXIS] 轴加速度',
        'domiAiRound.batteryLevel': '圆屏剩余电量',
        'domiAiRound.calibrateTilt': '将当前圆屏姿势设为水平中心',
        'domiAiRound.openTiltCore': '打开丝滑能量球界面，初始能量 [ENERGY]',
        'domiAiRound.updateTiltCore': '将能量球移动到 x [X] y [Y]，能量 [ENERGY]',
        'domiAiRound.openSpaceScene': '打开丝滑星际飞船场景，初始得分 [SCORE]',
        'domiAiRound.updateSpaceScene': '更新飞船 x [SHIP_X]、陨石 x [METEOR_X] y [METEOR_Y]、得分 [SCORE]、护盾 [SHIELD]',
        'domiAiRound.name': 'Domi AI 圆屏',
        'domiAiRound.playIconAnimation': '播放图标 [ANIMATION] 动画 [TIMES] 次',
        'domiAiRound.playSoundEffect': '播放圆屏 [SOUND] 音效',
        'domiAiRound.soundEffect.click': '点击',
        'domiAiRound.soundEffect.powerUp': '能量启动',
        'domiAiRound.soundEffect.roll': '骰子滚动',
        'domiAiRound.soundEffect.success': '挑战成功',
        'domiAiRound.setBackgroundColor': '将圆屏背景设为 [COLOR]',
        'domiAiRound.setBrightness': '将圆屏亮度设为 [BRIGHTNESS] %',
        'domiAiRound.setGradientBackground': '将圆屏渐变设为 [COLOR1] 到 [COLOR2] [DIRECTION]',
        'domiAiRound.shapeStyle.fill': '实心',
        'domiAiRound.shapeStyle.outline': '空心',
        'domiAiRound.showIcon': '在圆屏 x [X] y [Y] 显示 [ICON] 图标 大小 [SIZE] 颜色 [COLOR]',
        'domiAiRound.showProgressRing': '在圆屏 x [X] y [Y] 显示进度 [VALUE] % 半径 [RADIUS] 颜色 [COLOR]',
        'domiAiRound.touchX': '圆屏触摸位置 x',
        'domiAiRound.touchY': '圆屏触摸位置 y',
        'domiAiRound.tiltAngle': '圆屏 [DIRECTION] 倾斜角度',
        'domiAiRound.tiltDirection.frontBack': '前后',
        'domiAiRound.tiltDirection.leftRight': '左右',
        'domiAiRound.whenShaken': '当圆屏被摇动',
        'domiAiRound.whenTouchReleased': '当手指离开圆屏',
        'domiAiRound.whenTouched': '当圆屏被触摸',
        'gui.domiCar.camera.close': '关闭摄像头画面',
        'gui.domiCar.camera.collapse': '退出大画面',
        'gui.domiCar.camera.expand': '放大摄像头画面',
        'gui.domiCar.camera.loadError': '摄像头画面加载失败',
        'gui.domiCar.camera.title': '小车摄像头',
        'gui.domiCar.upload': '烧录中心',
        'gui.domiCar.burnCenter.close': '关闭烧录中心',
        'gui.domiCar.burnCenter.completed': '烧录完成',
        'gui.domiCar.burnCenter.connected': '小车已连接',
        'gui.domiCar.burnCenter.connectHelp': '请先在 Domi 小车积木中连接小车，再开始烧录。',
        'gui.domiCar.burnCenter.controllerPressed': '当控制器 {button} 被按下',
        'gui.domiCar.burnCenter.controllerReleased': '当控制器 {button} 被松开',
        'gui.domiCar.burnCenter.disconnected': '小车未连接',
        'gui.domiCar.burnCenter.error': '程序无法烧录。',
        'gui.domiCar.burnCenter.instructionCount': '共 {count} 条指令',
        'gui.domiCar.burnCenter.intro': '写入小车前，请先核对下面即将烧录的程序。',
        'gui.domiCar.burnCenter.lightOff': '关闭小车灯',
        'gui.domiCar.burnCenter.lightOn': '打开小车灯',
        'gui.domiCar.burnCenter.lightToggle': '切换小车灯',
        'gui.domiCar.burnCenter.moveBackward': '小车后退',
        'gui.domiCar.burnCenter.moveForward': '小车前进',
        'gui.domiCar.burnCenter.preparing': '正在检查 Scratch 程序…',
        'gui.domiCar.burnCenter.previewTitle': '即将烧录的内容',
        'gui.domiCar.burnCenter.powerOnEvent': '当小车开机时',
        'gui.domiCar.burnCenter.ready': '程序检查完成，可以开始烧录。',
        'gui.domiCar.burnCenter.safety': '安全提示：烧录后小车可能立即运动，请先架空车轮并清理周围空间。',
        'gui.domiCar.burnCenter.start': '开始烧录',
        'gui.domiCar.burnCenter.stop': '停止小车',
        'gui.domiCar.burnCenter.success': '烧录成功，开机事件和控制器事件已保存到小车。',
        'gui.domiCar.burnCenter.title': '小车烧录中心',
        'gui.domiCar.burnCenter.turnLeft': '小车左转',
        'gui.domiCar.burnCenter.turnRight': '小车右转',
        'gui.domiCar.burnCenter.uploading': '正在把程序写入小车…',
        'gui.domiCar.burnCenter.wait': '等待 {seconds} 秒',
        'gui.microbit.burnCenter.browserHelp': '请使用桌面版 Chrome 或 Edge，并通过 HTTPS 或 localhost 打开 Domi Scratch。',
        'gui.microbit.burnCenter.clear': '清空显示屏',
        'gui.microbit.burnCenter.close': '关闭烧录中心',
        'gui.microbit.burnCenter.compile': '重新编译',
        'gui.microbit.burnCenter.carLight': '将 Domi 小车灯设为 {state}',
        'gui.microbit.burnCenter.carMove': 'Domi 小车运动 {direction}',
        'gui.microbit.burnCenter.carStop': '停止 Domi 小车',
        'gui.microbit.burnCenter.completed': '烧录完成',
        'gui.microbit.burnCenter.displayLed': '显示 LED 图案',
        'gui.microbit.burnCenter.displayText': '显示文字“{text}”',
        'gui.microbit.burnCenter.error': '程序无法烧录。',
        'gui.microbit.burnCenter.eventButton': '当按下 {button} 按钮',
        'gui.microbit.burnCenter.eventButtonAny': '当按下任意按钮',
        'gui.microbit.burnCenter.eventStart': '当 micro:bit 启动时',
        'gui.microbit.burnCenter.eventTiltAny': '当向任意方向倾斜',
        'gui.microbit.burnCenter.eventTiltBack': '当向后倾斜',
        'gui.microbit.burnCenter.eventTiltFront': '当向前倾斜',
        'gui.microbit.burnCenter.eventTiltLeft': '当向左倾斜',
        'gui.microbit.burnCenter.eventTiltRight': '当向右倾斜',
        'gui.microbit.burnCenter.instructionCount': '共 {count} 条指令',
        'gui.microbit.burnCenter.intro': '写入 micro:bit 前，请先核对下面即将烧录的离线程序。',
        'gui.microbit.burnCenter.preparing': '正在编译 Scratch 程序…',
        'gui.microbit.burnCenter.previewTitle': '即将烧录的内容',
        'gui.microbit.burnCenter.ready': '程序编译完成，可以开始烧录。',
        'gui.microbit.burnCenter.repeat': '重复执行 {count} 次',
        'gui.microbit.burnCenter.repeatEnd': '重复结束',
        'gui.microbit.burnCenter.safety': '请使用 USB 数据线连接 micro:bit，烧录过程中不要拔线。',
        'gui.microbit.burnCenter.start': '开始烧录',
        'gui.microbit.burnCenter.success': '烧录成功，程序已在 micro:bit 上运行。',
        'gui.microbit.burnCenter.supported': '支持 USB 烧录',
        'gui.microbit.burnCenter.title': 'micro:bit 烧录中心',
        'gui.microbit.burnCenter.unsupported': '当前无法 USB 烧录',
        'gui.microbit.burnCenter.uploading': '正在把程序写入 micro:bit…',
        'gui.microbit.burnCenter.wait': '等待 {seconds} 秒',
        'microbit.offline.compileFailed': '无法编译 micro:bit 离线程序。',
        'microbit.offline.dynamicInput': '离线程序中的文字、显示、等待和重复参数必须填写固定值。',
        'microbit.offline.multipleEntries': '只能保留一段“当 micro:bit 启动时”程序。',
        'microbit.offline.noEntry': '请至少搭建一段 micro:bit 启动、按键或倾斜事件程序。',
        'microbit.offline.repeatRange': '离线程序每次最多重复 100 次。',
        'microbit.offline.tooLarge': 'micro:bit 离线程序太长，请减少积木。',
        'microbit.offline.unsupportedBlock': '程序中包含暂不支持 micro:bit 离线运行的积木。',
        'microbit.offline.waitRange': '离线程序每次等待必须在 0 到 60 秒之间。',
        'microbit.whenMicrobitStarts': '当 micro:bit 启动时'
    }
};

const initialState = {
    isRtl: false,
    locale: 'en',
    messagesByLocale,
    messages: messagesByLocale.en
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SELECT_LOCALE:
        return Object.assign({}, state, {
            isRtl: isRtl(action.locale),
            locale: action.locale,
            messagesByLocale: state.messagesByLocale,
            messages: state.messagesByLocale[action.locale]
        });
    case UPDATE_LOCALES:
        return Object.assign({}, state, {
            isRtl: state.isRtl,
            locale: state.locale,
            messagesByLocale: action.messagesByLocale,
            messages: action.messagesByLocale[state.locale]
        });
    default:
        return state;
    }
};

const selectLocale = function (locale) {
    return {
        type: SELECT_LOCALE,
        locale: locale
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages
    };
};
const initLocale = function (currentState, locale) {
    if (Object.prototype.hasOwnProperty.call(currentState.messagesByLocale, locale)) {
        return Object.assign(
            {},
            currentState,
            {
                isRtl: isRtl(locale),
                locale: locale,
                messagesByLocale: currentState.messagesByLocale,
                messages: currentState.messagesByLocale[locale]
            }
        );
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales
};
